import { render, staticRenderFns } from "./columns.vue?vue&type=template&id=03332003"
import script from "./columns.vue?vue&type=script&lang=js"
export * from "./columns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03332003')) {
      api.createRecord('03332003', component.options)
    } else {
      api.reload('03332003', component.options)
    }
    module.hot.accept("./columns.vue?vue&type=template&id=03332003", function () {
      api.rerender('03332003', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/main/columns.vue"
export default component.exports